import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/nhan-su/gia-dinh'

// Lọc gia đình
export function locGiaDinh(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach-gia-dinh`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy gia đình nhân viên
export function layGiaDinhNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/gia-dinh`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy liên hệ khẩn cấp nhân viên
export function layLienHeKhanCapNhanVien(userId: number) {
  try {
    return axiosApi.get(`${BASE}/nhan-vien/${userId}/gia-dinh/lien-he-khan-cap`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo gia đình nhân viên
export function taoGiaDinhNhanVien(userId: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/tao-gia-dinh-nhan-vien?userId=${userId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật gia đình nhân viên
export function capNhatGiaDinhNhanVien(familyId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${familyId}/cap-nhat-gia-dinh-nhan-vien`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa gia đình nhân viên
export function xoaGiaDinhNhanVien(familyId: number) {
  try {
    return axiosApi.delete(`${BASE}/${familyId}/xoa-gia-dinh-nhan-vien`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
